/**
 * Public entrypoint for recording and observing Completions. IndexedDB,
 * Supabase, retry, and browser-connectivity details are private to this folder.
 */
import type { SupabaseClient } from '@supabase/supabase-js';
import { useSyncExternalStore } from 'react';

import type { Database } from '../database.types.js';
import {
  createCompletionLog,
  type CompletionLog,
  type CompletionLogSnapshot,
} from './completionLog.js';
import { createIndexedDbOutbox } from './internal/indexedDbOutbox.js';
import { createSupabaseCompletionRemote } from './internal/supabaseRemote.js';

export type { CompletionLog, CompletionLogSnapshot } from './completionLog.js';

export const createBrowserCompletionLog = (client: SupabaseClient<Database>): CompletionLog =>
  createCompletionLog(
    createSupabaseCompletionRemote(client),
    createIndexedDbOutbox(window.indexedDB),
    window,
  );

export const useCompletionLog = (log: CompletionLog): CompletionLogSnapshot =>
  useSyncExternalStore(log.subscribe, log.getSnapshot, log.getSnapshot);
